const namingOfMachineType = {
	APP: 'App (Product)',
	MACHINE: 'Machine (Product)',
	ASSET: 'Asset',
	MRD: 'MRD',
	FMCG: 'FMCG (Secondary Packaging)',
};

const labelGeneratorConfig = {
	namingOfMachineType,
};

export default labelGeneratorConfig;
